import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp } from "../core/components/commonApp";
import { Grid } from "../core/components/grid";
import { Helper } from "../core/util/helper";
import { Config } from "../core/config/config";
import { HTTPService } from "../core/util/httpManager";
import { GridCustomToolBarButton } from "../core/components/toolBar";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export class QRReportsApp extends React.Component<AppBaseProps, any>{
    private _qrReportsGridData: Array<any> = [];
    private _qrReportsGridRef: Grid;
    private _selectedQRReportsItem: any;
    private _editQRReportsEnabled: boolean = false;
    common = new AppHelper();
    setTabTitle = true;
    translations: StringKeyDictionary<string>;
    qrReportsGridOptions: kendo.ui.GridOptions;

    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
    }

    private _getQRReportsGridData = () => {
        HTTPService.get("PrintService/GetQRReportsGridData")
            .then(result => {
                Helper.setArrayValues(this._qrReportsGridData, result);
                this.setState({});
            });
    }

    private _qrReportsSelectionChanged = (dataItem) => {
        const prevEditEnabled = this._editQRReportsEnabled;
        this._editQRReportsEnabled = Helper.hasValue(dataItem);
        this._selectedQRReportsItem = dataItem;
        if (prevEditEnabled !== this._editQRReportsEnabled) {
            this.setState({});
        }
    }

    private _downloadQRReportsEntry = (dataItem) => {
        window.location.href = Config.baseUrl + "PrintService/DownloadQRReport?user=" + dataItem.user + "&fileName=" + dataItem.fileName;
    }

    private _handleQRReportsDownloadButtonClick = (id: string, dataItem: any) => {
        if (id === "downloadReport") {
            this._downloadQRReportsEntry(dataItem);
        }
    }

    createGrid = () => {
        var customButtons: Array<GridCustomToolBarButton> = [];
        customButtons.push({ id: "downloadReport", autoEnabledOnRecordSelected: true, width: "120px", iconClass: "k-i-seek-s", caption: this.translations["Server.Download"], enabled: this.props.entity.RecordRight.CanWrite });

        return (
            <div className="flex-container">
                <div className="flex-container__item flex-containter" >
                    <Grid data={this._qrReportsGridData} options={this.qrReportsGridOptions} id="qrReports"
                        onSelectionChanged={this._qrReportsSelectionChanged} ref={(r) => this._qrReportsGridRef = r}
                        customButtons={customButtons} onClickCustomButton={this._handleQRReportsDownloadButtonClick} />
                </div>
            </div>
        );
    }

    componentDidMount() {
        this._getQRReportsGridData();
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps());
        return <CommonApp {...props} />;
    }
}
